<!-- Copy Order Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowOrderCopy" (click)="ShowOrderCopy = false; CurrentOrder = null;">
  <div class="ModernPopup small" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #667eea;">content_copy</i>
        <span>{{ 'CopyOfferRequestTitle' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowOrderCopy = false; CurrentOrder = null;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p class="ModernPopupDescription" style="text-align: center;">{{ 'CopyOfferRequestDescription' | translate }}</p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowOrderCopy = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button class="ModernButton primary" [disabled]="this.parent.loading" (click)="ShowOrderCopy = false;CopyOrder(CurrentOrder);">
        <i class="material-icons">content_copy</i>
        <span>{{ 'AcceptAndContinueCopy' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Cancel Order Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowOrderCancelation" (click)="ShowOrderCancelation = false; CurrentOrder = null;">
  <div class="ModernPopup small" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #fd4f57;">warning</i>
        <span>{{ 'CancelQuestion' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowOrderCancelation = false; CurrentOrder = null;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p class="ModernPopupDescription" style="text-align: center;">{{ 'CancelQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowOrderCancelation = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowOrderCancelation = false;CancelOrder(CurrentOrder);">
        <i class="material-icons">close</i>
        <span>{{ 'YesCancel' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Main Requests Container (iOS frosted glass design matching my-orders) -->
<div class="profile-container" *ngIf="ShowEditContainer != true;">
  <div class="profile-header">
    <h1>{{'MyOffers' | translate}}</h1>
  </div>

  <div class="profile-card">
    <div class="card-content">
      <!-- Filter Bar Row -->
      <div class="MainTitleBar">
        <div class="FifteenPercentContainer">
          <div class="CustomDropdownContainer">
            <div class="SendEmailOverlayTransparent" *ngIf="showPeriodDropdown" (click)="showPeriodDropdown = false"></div>
            <div class="CustomDropdownBar" (click)="showPeriodDropdown = !showPeriodDropdown">
              <span class="dropdown-label">{{ 'Receptions.ChoosePeriod' | translate }}</span>
              <i class="material-icons dropdown-icon-left">date_range</i>
              <input type="text" class="CustomDropdownInput" [value]="Filter.Period?.Name || ''" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="showPeriodDropdown">
              <div class="CustomDropdownResult" *ngFor="let a of this.MasterData.Periods" (click)="Filter.Period = a; showPeriodDropdown = false; AddActiveFilter(a.Name, 'Period'); GetOrdersFiltered();">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons" [style.color]="Filter.Period?.ID === a.ID ? '#34c759' : '#c7c7cc'">
                    {{ Filter.Period?.ID === a.ID ? 'check_circle' : 'radio_button_unchecked' }}
                  </i>
                  <span class="CustomDropdownResultText">{{a.Name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="FifteenPercentContainer">
          <div class="CustomDatePickerBar" (click)="dp.open()">
            <span class="dropdown-label">{{ 'Receptions.FromDate' | translate }}</span>
            <i class="material-icons dropdown-icon-left">event</i>
            <input matInput class="CustomDateInput" [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()" readonly>
            <mat-datepicker-toggle matSuffix [for]="dp" class="CustomDateToggle"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </div>
        </div>

        <div class="FifteenPercentContainer">
          <div class="CustomDatePickerBar" (click)="dp1.open()">
            <span class="dropdown-label">{{ 'Receptions.ToDate' | translate }}</span>
            <i class="material-icons dropdown-icon-left">event</i>
            <input matInput class="CustomDateInput" [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (dateChange)="ClearPeriod()" readonly>
            <mat-datepicker-toggle matSuffix [for]="dp1" class="CustomDateToggle"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </div>
        </div>

        <button class="GridCommandButton GridCommandButtonBlue" (click)="GetOrdersFiltered();">
          <i class="material-icons">filter_alt</i>
          <span>{{ 'Filter' | translate }}</span>
        </button>

        <!-- Search Bar -->
        <div class="MainOrdersSearchContainer">
          <input type="text" class="MainOrdersSearch" placeholder="{{'SearchByProduct' | translate}}" [(ngModel)]="this.Filter.SearchTerm" (ngModelChange)="this.searchMainOrders.next($event)">
          <i class="material-icons" *ngIf="!this.LoadingMainSearchTerm && !(this.Filter?.SearchTerm?.length > 0);" (click)="GetOrdersFiltered();">search</i>
          <i class="material-icons" *ngIf="!this.LoadingMainSearchTerm && this.Filter?.SearchTerm?.length > 0;" (click)="ResetMainSearch();">close</i>
          <mat-spinner class="smallSpinner" [diameter]="18" *ngIf="this.LoadingMainSearchTerm == true;"></mat-spinner>
        </div>

        <!-- Pagination -->
        <div class="RightPagination">
          <div class="PaginationControls">
            <button class="GridCommandButton PaginationButton" [disabled]="this.Filter.Pager.PageIndex == 1" (click)="GetOrdersFiltered(1);">
              <i class="material-icons">first_page</i>
            </button>
            <button class="GridCommandButton PaginationButton" [disabled]="this.Filter.Pager.PageIndex == 1" (click)="GetOrdersFiltered(this.Filter.Pager.PageIndex - 1);">
              <i class="material-icons">chevron_left</i>
            </button>
            <div class="PageNumberDisplay">
              <span class="CurrentPage">{{this.Filter.Pager.PageIndex}}</span>
              <span class="PageSeparator">/</span>
              <span class="TotalPages">{{this.Filter.Pager.Pages}}</span>
            </div>
            <button class="GridCommandButton PaginationButton" [disabled]="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages" (click)="GetOrdersFiltered(this.Filter.Pager.PageIndex + 1);">
              <i class="material-icons">chevron_right</i>
            </button>
            <button class="GridCommandButton PaginationButton" [disabled]="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages" (click)="GetOrdersFiltered(this.Filter.Pager.Pages);">
              <i class="material-icons">last_page</i>
            </button>
          </div>
        </div>
      </div>

      <!-- Active Filters -->
      <div class="ActiveFiltersContainer" *ngIf="this.activeFilters?.length > 0" style="padding: 0 20px; margin-bottom: 10px;">
        <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
          {{a.Name}}
          <i class="material-icons">close</i>
        </div>
      </div>

      <!-- Modern Orders Table (matching my-orders style) -->
      <div class="ModernOrdersTable">
        <div class="ModernOrdersHeader">
          <div class="ModernOrdersHeaderCol" style="width: 4%;">
            <i class="material-icons">tag</i>
          </div>
          <div class="ModernOrdersHeaderCol" style="width: 14%;">
            {{'ID' | translate}}
          </div>
          <div class="ModernOrdersHeaderCol" style="width: 14%;">
            {{'Status' | translate}}
          </div>
          <div class="ModernOrdersHeaderCol" style="width: 10%;">
            {{'Date' | translate}}
          </div>
          <div class="ModernOrdersHeaderCol" style="width: 14%;">
            {{'DebatorPO' | translate}}
          </div>
          <div class="ModernOrdersHeaderCol" style="width: 10%;">
            {{'Total' | translate}}
          </div>
          <div class="ModernOrdersHeaderCol" style="width: 6%;">
            {{'Currency' | translate}}
          </div>
          <div class="ModernOrdersHeaderCol" style="width: 14%;">
            {{'Agent' | translate}}
          </div>
          <div class="ModernOrdersHeaderCol" style="width: 14%;">
            {{'Actions' | translate}}
          </div>
        </div>

        <div class="ModernOrdersBody">
          <div *ngIf="this.loadingOrders == false;">
            <div class="ModernOrdersRow" *ngFor="let o of this.Orders; let j=index;" (dblclick)="GetOffer(o.ID);">
              <div class="ModernOrdersCol" style="width: 4%;">
                <span class="row-number">#{{j + 1}}</span>
              </div>

              <div (click)="GetOffer(o.ID);" class="ModernOrdersCol order-id-col" style="width: 14%;">
                <span class="order-id-link">{{o.ReferenceNumber}}</span>
              </div>

              <div class="ModernOrdersCol" style="width: 14%;">
                <span class="modern-status-badge status-expired" *ngIf="o.OfferValidityStatus == -1">
                  {{'Expired' | translate}}
                </span>
                <span class="modern-status-badge" *ngIf="o.OfferValidityStatus != -1" [ngClass]="{
                  'status-new': o.OfferStatus?.ID == -1,
                  'status-processing': o.OfferStatus?.ID == 1,
                  'status-partial': o.OfferStatus?.ID == 9,
                  'status-completed': o.OfferStatus?.ID == 10 || o.OfferStatus?.ID == 12,
                  'status-canceled': o.OfferStatus?.ID == 11
                }">
                  {{o.OfferStatus?.Name}}
                </span>
              </div>

              <div class="ModernOrdersCol" style="width: 10%;">
                <div class="order-date-stack">
                  <span class="order-date">{{o.EventRegisterUI}}</span>
                  <span class="order-validity" *ngIf="o.ValidUntilUI">exp.: {{o.ValidUntilUI}}</span>
                </div>
              </div>

              <div class="ModernOrdersCol" style="width: 14%;">
                <span class="order-po">{{o.DebatorPO}}</span>
              </div>

              <div class="ModernOrdersCol" style="width: 10%;">
                <span class="order-total">{{o.Cart?.Total?.UITotalQtyPriceNOVAT?.Integer}}{{o.Cart?.Total?.UITotalQtyPriceNOVAT?.Decimals}}</span>
              </div>

              <div class="ModernOrdersCol" style="width: 6%;">
                <span class="order-currency">{{o.Cart?.Currency?.Name}}</span>
              </div>

              <div class="ModernOrdersCol" style="width: 14%;">
                <span class="order-agent">{{o.UserManager?.Email}}</span>
              </div>

              <div class="ModernOrdersCol" style="width: 14%;">
                <button (click)="GetOffer(o.ID);" class="ModernDetailsButton">
                  <i class="material-icons">visibility</i>
                  <span>{{'Details' | translate}}</span>
                </button>
              </div>
            </div>
          </div>
          <div *ngIf="this.loadingOrders == true;" class="empty-state">
            <mat-spinner diameter="24" class="BrandsLoadingSpinner"></mat-spinner>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Offer Details Page -->
<div class="offer-details-page" *ngIf="this.ShowEditContainer == true && this.CurrentOrder != null;">

  <!-- Status Header Bar (stretched at top) -->
  <div class="status-header-bar" [ngClass]="{
    'status-new': CurrentOrder.OfferStatus?.ID == -1,
    'status-processing': CurrentOrder.OfferStatus?.ID == 1,
    'status-partial': CurrentOrder.OfferStatus?.ID == 9,
    'status-completed': CurrentOrder.OfferStatus?.ID == 10 || CurrentOrder.OfferStatus?.ID == 12,
    'status-canceled': CurrentOrder.OfferStatus?.ID == 11
  }">
    <button class="back-button" (click)="this.ShowEditContainer = false; this.CurrentOrder = null;">
      <i class="material-icons">arrow_back</i>
    </button>
    <img *ngIf="parent?.Company?.LogoPath?.length > 0" class="header-logo" [src]="parent.APIUrl + parent.Company.LogoPath" onerror="this.style.display='none'" />
    <span class="status-text">{{CurrentOrder.OfferStatus?.Name}}</span>
    <button class="header-accept-button" *ngIf="CurrentOrder.OfferStatus?.ID == 9 && CurrentOrder.OfferValidityStatus != -1" (click)="goToAcceptOffer()">
      <span>{{'AcceptOfferHere' | translate}}</span>
      <i class="material-icons">arrow_forward</i>
    </button>
    <span class="ref-number" *ngIf="CurrentOrder.OfferStatus?.ID != 9 || CurrentOrder.OfferValidityStatus == -1">{{ CurrentOrder.ReferenceNumber }}</span>
  </div>

  <!-- Main Container -->
  <div class="details-main-container">
    <div class="details-content-container">

      <!-- Company Header Section -->
      <div class="company-header-section">
        <div class="company-logo-area">
          <img *ngIf="parent?.Company?.LogoPath?.length > 0" class="company-logo" [src]="parent.APIUrl + parent.Company.LogoPath" onerror="this.style.display='none'" />
        </div>
        <div class="company-info-area">
          <div class="company-name-text">{{ CurrentOrder?.Company?.Name || parent?.Company?.Name }}</div>
          <div class="company-address-text" *ngIf="parent?.Company?.Addresses?.length > 0">
            {{ parent.Company.Addresses[0]?.City }}, {{ parent.Company.Addresses[0]?.Country?.Name }}
          </div>
          <div class="contact-info" *ngIf="CurrentOrder?.UserManager?.Phone || CurrentOrder?.UserManager?.Email">
            <span *ngIf="CurrentOrder?.UserManager?.Phone"><i class="material-icons">phone</i> {{ CurrentOrder.UserManager.Phone }}</span>
            <span *ngIf="CurrentOrder?.UserManager?.Email"><i class="material-icons">email</i> {{ CurrentOrder.UserManager.Email }}</span>
          </div>
        </div>
      </div>

      <!-- Reference Numbers Row -->
      <div class="reference-section">
        <div class="reference-group-left">
          <div class="reference-item">
            <span class="reference-value">{{ CurrentOrder.ReferenceNumber }}</span>
            <span class="reference-label">{{'OurReference' | translate}}</span>
          </div>
          <div class="reference-item" *ngIf="CurrentOrder.DebatorPO">
            <span class="reference-value debator-po">{{ CurrentOrder.DebatorPO }}</span>
            <span class="reference-label">{{'YourReference' | translate}}</span>
          </div>
        </div>
        <div class="reference-group-right">
          <div class="reference-date-item" *ngIf="CurrentOrder.EventRegisterUI">
            <span class="reference-date-label">{{'Date' | translate}}:</span>
            <span class="reference-date-value">{{ CurrentOrder.EventRegisterUI }}</span>
          </div>
          <div class="reference-date-item" *ngIf="CurrentOrder.ValidUntilUI">
            <span class="reference-date-label">exp.:</span>
            <span class="reference-date-value order-validity">{{ CurrentOrder.ValidUntilUI }}</span>
          </div>
        </div>
      </div>

      <!-- Billing & Shipping Info Section -->
      <div class="info-section" *ngIf="CurrentOrder?.Cart?.Partner">
        <!-- Billing Information -->
        <div class="info-box billing-box">
          <div class="info-box-header">
            <i class="material-icons">receipt</i>
            <span>{{'BillingInformation' | translate}}</span>
            <i class="material-icons lock-icon">lock</i>
          </div>
          <div class="info-box-content">
            <div class="info-row">
              <span class="info-label">{{'Company' | translate}}:</span>
              <span class="info-value">{{ CurrentOrder.Cart.Partner?.Name }}</span>
            </div>
            <div class="info-row" *ngIf="CurrentOrder.Cart.Partner?.VAT">
              <span class="info-label">{{'VAT' | translate}}:</span>
              <span class="info-value">{{ CurrentOrder.Cart.Partner?.VAT }}</span>
            </div>
            <div class="info-row" *ngIf="CurrentOrder.Cart.Partner?.BillingAddress">
              <span class="info-label">{{'Address' | translate}}:</span>
              <span class="info-value">
                {{ CurrentOrder.Cart.Partner?.BillingAddress?.AddressLine }}<span *ngIf="CurrentOrder.Cart.Partner?.BillingAddress?.City">, {{ CurrentOrder.Cart.Partner?.BillingAddress?.City }}</span><span *ngIf="CurrentOrder.Cart.Partner?.BillingAddress?.ZipCode">, {{ CurrentOrder.Cart.Partner?.BillingAddress?.ZipCode }}</span><span *ngIf="CurrentOrder.Cart.Partner?.BillingAddress?.Country?.Name">, {{ CurrentOrder.Cart.Partner?.BillingAddress?.Country?.Name }}</span>
              </span>
            </div>
          </div>
        </div>

        <!-- Shipping Information -->
        <div class="info-box shipping-box">
          <div class="info-box-header">
            <i class="material-icons">local_shipping</i>
            <span>{{'ShippingAddress' | translate}}</span>
            <i class="material-icons lock-icon">lock</i>
          </div>
          <div class="info-box-content">
            <div class="info-row" *ngIf="CurrentOrder.ShippingAddress?.ContactName">
              <span class="info-label">{{'Contact' | translate}}:</span>
              <span class="info-value">{{ CurrentOrder.ShippingAddress?.ContactName }}</span>
            </div>
            <div class="info-row" *ngIf="CurrentOrder.ShippingAddress">
              <span class="info-label">{{'Address' | translate}}:</span>
              <span class="info-value">
                {{ CurrentOrder.ShippingAddress?.AddressLine }}<span *ngIf="CurrentOrder.ShippingAddress?.City">, {{ CurrentOrder.ShippingAddress?.City }}</span><span *ngIf="CurrentOrder.ShippingAddress?.ZipCode">, {{ CurrentOrder.ShippingAddress?.ZipCode }}</span><span *ngIf="CurrentOrder.ShippingAddress?.Country?.Name">, {{ CurrentOrder.ShippingAddress?.Country?.Name }}</span>
              </span>
            </div>
            <div class="info-row" *ngIf="!CurrentOrder.ShippingAddress">
              <span class="info-value" style="color: #9ca3af; font-style: italic;">{{'NoShippingAddressSelected' | translate}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Cart Items Table -->
      <div class="cart-section" *ngIf="CurrentOrder?.Cart?.Items?.length > 0">
        <div class="modern-table-container">
          <table class="modern-table">
            <thead>
              <tr>
                <th style="width: 45px;" class="text-center">#</th>
                <th>{{'Product' | translate}}</th>
                <th style="width: 60px; text-align: center;">{{'Quantity' | translate}}</th>
                <th style="width: 105px; text-align: right;">{{'UnitPrice' | translate}}</th>
                <th style="width: 105px; text-align: right;">{{'Total' | translate}} ({{ CurrentOrder.Cart.Currency?.Symbol }})</th>
                <th style="width: 110px; text-align: center;">{{'LeadTime' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of CurrentOrder.Cart.Items; let i = index">
                <td class="text-center" style="color: #aeaeb2; font-weight: 600; font-size: 11px;">{{ i + 1 }}</td>
                <td>
                  <div>
                    <strong style="font-size: 12px; font-style: italic;">{{ item.Product?.Brand?.Name }}</strong>
                    <span *ngIf="item.Product?.PartNumber" style="color: #8e8e93; font-size: 11px; font-style: italic; margin-left: 4px;">[{{ item.Product?.PartNumber }}]</span>
                  </div>
                  <div style="color: #1c1c1e; font-size: 12px; font-style: italic; margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 350px;">{{ item.Product?.Name || item.UIProductValue }}</div>
                </td>
                <td class="text-center" style="font-weight: 600;">{{ item.Quantity }}</td>
                <td class="text-right" style="font-weight: 500;">{{ item.Price?.UIUnitPrice || '-' }}</td>
                <td class="text-right" style="font-weight: 600;">{{ item.Price?.UIQtyPrice || '-' }}</td>
                <td class="text-center">
                  <span class="lead-time-badge" *ngIf="item.SelectedOffer?.LeadTime?.Type?.Name">
                    {{ item.SelectedOffer?.LeadTime?.Units }} {{ item.SelectedOffer?.LeadTime?.Type?.Name }}
                  </span>
                  <span *ngIf="!item.SelectedOffer?.LeadTime?.Type?.Name" style="color: #c7c7cc;">-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Totals Section -->
      <div class="totals-section" *ngIf="CurrentOrder?.Cart?.Total">
        <div class="total-row absolute-total-row">
          <span class="total-label">{{'Total' | translate}}:</span>
          <span class="total-value absolute-total-value">{{ CurrentOrder.Cart?.Total?.UITotalQtyPriceNOVAT?.Integer }}{{ CurrentOrder.Cart?.Total?.UITotalQtyPriceNOVAT?.Decimals }} {{ CurrentOrder.Cart?.Currency?.Name }}</span>
        </div>
      </div>

      <!-- Accept Button Section - Only show for status ID 9 (Awaiting Acceptance by Client) AND not expired -->
      <div class="accept-section" *ngIf="CurrentOrder.OfferStatus?.ID == 9 && CurrentOrder.OfferValidityStatus != -1">
        <button class="accept-button" (click)="goToAcceptOffer()">
          <i class="material-icons">check_circle</i>
          <span>{{'AcceptOfferHere' | translate}}</span>
        </button>
      </div>

    </div>
  </div>
</div>

